<template>
    <div class="main-container">
      <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <div class="reptitle margintop-32">
            <!-- <div> -->
            <span>Total Reportee</span>
            <span>Direct Reportee</span>
            <span>Indirect Reportee</span>
            <span></span>
            
            <span><b>{{totalCount}}</b></span>
            <span><b>{{directReporteeCount}}</b></span>
            <span><b>{{indirectReporteeCount}}</b></span>
        </div>
        <!-- <br><br><br><br><br><br> -->
        <!-- <tl-header type="h1">My Reportees</tl-header> -->
         <br><br>
        <div class="margintop-32">
      <tl-tabs :tabs="tabs">
        <tl-tab>
          <direct-reportee></direct-reportee>
        </tl-tab>
        <tl-tab>
          <indirect-reportee :indirectReporteesList="indirectReporteesList" :tableData="indirectReporteesList"></indirect-reportee>
        </tl-tab>
      </tl-tabs>
    </div>
         
    </div>
   
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import directReportee from "./directReportee.vue";
import indirectReportee from "./indirectReportee.vue";

export default {
  components:{
    directReportee,
    indirectReportee
  },
  data(){
      return{
        breadcrumbList:[
        {
          name: "Home",
          url: `/dashboard/${this.$route.params.entity_index}/overview/feed`
        },
        {
          name: "My Team",
          url: `/dashboard/${this.$route.params.entity_index}/myteam/reportees`
        }
      ],
      tabs: [
        {
          header: "Direct Reportee",
        },
        {
          header: "Indirect Reportee",
        },
      ],
      showTag: true,
      showSuccessMsg: false,
      actionTypeVar: "",
      showPopup: false,
      employeeData: [],
      directReporteesList: [],
      indirectReporteesList: [],
      directReporteeCount: null,
      indirectReporteeCount: null,
      totalCount: null,
      role: "",
      employee_id: "",
      }
  },
  mounted() {
    //this.activeExistEmployeeList();
    this.fetchMyTeamReportee();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },

    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
  },
  methods: {
    ...mapActions({
      //activeExistEmployee: "dashboard/organisation/employeeDirectory/fetchAll",
      fetchReportee: "dashboard/myteam/fetchAll",
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),
    
    async activeExistEmployeeList() {
      try {
        let res = await this.activeExistEmployee({
          le_id: this.le_id,
        });
        if (res.data.status) {
          this.activeList = res.data.payload.finalActiveEmployeeList;
          this.existList = res.data.payload.finalExitEmployeeList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async fetchMyTeamReportee() {
      try {
        const le = this.le_id;
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;
        //this.reportosValue = data.data.user.permissions.reportos ? true : false;
        
        let res = await this.fetchReportee({
          employee_id: this.employee_id,
        });
        //console.log(res);
        if (res.data.status) {
          this.directReporteesList = res.data.payload[0].directReportees.data;
          this.directReporteeCount = res.data.payload[0].directReportees.count;
          ////console.log("DircetList",this.directReporteesList);

          this.indirectReporteesList = res.data.payload[0].indirectReportees.data;
          this.indirectReporteeCount = res.data.payload[0].indirectReportees.count;
          
          this.totalCount = this.directReporteeCount + this.indirectReporteeCount;
          ////console.log("IndircetList",this.indirectReporteesList);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.employee_id = data.data.user.employee_id;
      //this.reportosValue = data.data.user.permissions.reportos ? true : false;
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.content{
    margin-left: 20px;
    margin-top: 20px;
    /* display: flex;
    flex-direction: column; */
}
.subtitle{
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}
.reptitle{
  width: 126px;
  height: 19px;
  font-family: Montserrat;
  font-size: 18px;
  display: grid;
  grid-template: repeat(2, 1fr)/ repeat(4, 1fr);
  grid-gap: 10px;
  width: 70%;
}
select .dropdown {
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    // width: 93px;
    // height: 35px;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
.selectdiv {
    select {
        width: 100%;
        border-radius: 4px;
        outline: 0;
        font-size: 14px;
        color: #9f9da2;
        border: 1px solid #dadada;
        padding: 0 10px;

      &.errorr{
        border: 1px solid #e01717;
      }
      &.errorMessage {
        color: #e01717;
      }
    }
    span{
       font-size: 12px;
       margin-left: 3px;
       color: #9f9da2;
    }
}
.recent{
  // grid-column: span 1;
  align-self: self-end;
}
.filters{
  // margin-right: 10px;
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(6, minmax(180px, 1fr));
}
.filterbtn{
  width: 60%;
  height: 65%;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  grid-column: -1/ -2;
  align-self: self-end;
  padding: 10px;
  margin-bottom: 3px;
}
.searchsort{
  display: flex;
  .selectdiv{
    width: 15%;
  }
}
.uploadDiv {
   width: 10%;
   margin-left: auto;  
   text-align: center;
   justify-content: end;
   padding: 4px 0px 0px 0px;
  // button{
  //   cursor: pointer;
  //   width: 60%;
  //   height: 70%;
  //   border-radius: 4px;
  //   color:#5d409f;
  //   border: 1px solid #5d409f;
  //   }
   img{
     height: 70%;
     margin-bottom: -10px;
   } 
}
.sorttext{
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons{
  width: 13%;
  padding: 8px 0px 5px 10px;
  span{
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}

.employees{
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(3, minmax(100px, 1fr));
  margin-right: 20px;
}
</style>
